<template>
  <div class="grid grid-cols-12 gap-4 p-6 md:p-8"><slot /></div>
</template>
